export const state = initialState();

export const actions = {};

export const mutations = {};

export const getters = {};

function initialState() {
  return {
    filterProperties: {
      aroundMe: [],
      projects: [
        {
          title: 'language',
          value: 'defaultLanguage',
          icon: 'translate',
          options: []
        },

        {
          title: 'projectVisibility',
          value: 'visibility',
          icon: 'visibility',
          options: []
          // options: [{name: "private", code: "private"}, {name: "public", code: "public"}]
        },

        { title: 'name', value: 'name', icon: 'title' }
      ],

      projectGroups: [
        { title: 'name', value: 'name', icon: 'title' },
        { title: 'groupLeaderName', value: 'nameGroupLeader', icon: 'title' }
      ],

      profiles: [
        {
          title: 'language',
          value: 'defaultLanguage',
          icon: 'translate',
          options: []
        },
        { title: 'name', value: 'name', icon: 'person' },
        { title: 'memberRole', value: 'roles.list', icon: 'person' },
        { title: 'tag', value: 'names.list', icon: 'person' }
      ],

      documents: [
        {
          title: 'language',
          value: 'defaultLanguage',
          icon: 'translate',
          options: []
        },
        //Name is insdie Template Array
        { title: 'name', value: 'name', icon: 'title' },
        { title: 'kindText', value: 'kind', icon: 'person' },
        { title: 'status', value: 'status', icon: 'policy', options: [] }
        // options: [{name : "denied", code: "rejected"}, {name : "availabeForSubmission", code: "pending"},
        //             {name : "underReview", code: "review"}, {name : "acceptedUpperCase", code: "accepted"},
        //             {name : "prePrublished", code: "prepublished"}, {name : "published", code: "published"},
        //             {name: "created", code: "created"}
        //           ] }
      ],

      templates: [
        {
          title: 'language',
          value: 'defaultLanguage',
          icon: 'translate',
          options: []
        },
        { title: 'name', value: 'name', icon: 'assignment' }
      ],

      pointsOfInterest: [
        {
          title: 'language',
          value: 'defaultLanguage',
          icon: 'translate',
          options: []
        },
        { title: 'name', value: 'name', icon: 'camera' }
      ],
      itineraries: [
        { title: 'location', value: 'location', icon: 'location_on' },
        {
          title: 'language',
          value: 'language',
          icon: 'translate',
          options: []
        },
        { title: 'name', value: 'name', icon: 'assignment' },
        { title: 'status', value: 'status', icon: 'policy', options: [] }
      ]
    }
  };
}
